export default {
    STC_SummaryAllocationDeliveryBar: 1,
    STC_SummaryAllocationDeliveryPie: 2,
    Fee_Expense_Chart: 3,
    Fee_Revenue_Chart: 4,
    Fee_Revenue_Detail_Chart: 30,
    Fee_Expense_Detail_Chart: 31,
    Business_Expense_Chart: 5,
    Budget_Expense_Chart: 10,
    Budget_Expense_ByTask_Chart: 11,
    Budget_Expense_Detail_Chart: 21,

    Business_Revenue_Chart: 15,

    Business_Revenue_Detail_Chart: 16,
    Budget_Expense_By_Field_Chart: 12,
    Budget_Expense_By_Property_Chart: 13,
    Business_Expense_Detail_Chart: 20,

    // Các DashboardType mới cho CQSN
    Fee_Expense_CQSN_Chart: 40,
    Fee_Revenue_CQSN_Chart: 41,
    Fee_Revenue_Detail_CQSN_Chart: 42,
    Fee_Expense_Detail_CQSN_Chart: 43,
    Business_Expense_CQSN_Chart: 44,
    Budget_Expense_CQSN_Chart: 45,
    Budget_Expense_By_Field_CQSN_Chart: 46,
    Budget_Expense_By_Property_CQSN_Chart: 47,
    Budget_Expense_ByTask_CQSN_Chart: 48,
    Business_Revenue_CQSN_Chart: 49,
    Business_Revenue_Detail_CQSN_Chart: 50,
    Business_Expense_Detail_CQSN_Chart: 51,
};
